import React from "react";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import { useNoticia } from "../hooks/useNoticia.jsx";
import { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import Parser from 'html-react-parser';
import { ListaNoticias } from "../components/ListaNoticias.jsx";
import { Titulo } from "../components/commons/Titulo.jsx";
import { Box } from "@mui/system";
import '../styles/Noticias.css'

export function Noticia() {
  const { key } = useParams();
  const { getNoticiaByKey } = useNoticia();
  const [noticia, setNoticia] = useState(null);

  useEffect(() => {
    getNoticiaByKey(key, null)
      .then(
        (noticia) => {
          setNoticia(noticia);
        },
        (promiseError) => {
          console.error("Error: " + promiseError);
        }
      );
  }, [key]);

  return (
    <>
      {noticia && (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Typography variant="h1">{noticia.titulo}</Typography>
            {noticia.fecha_creacion && (
              <Typography variant="h2" gutterBottom sx={{ marginBottom: "2em", textAlign: "center" }}>
                {noticia.fecha_creacion}
              </Typography>
            )}
          </Grid>
          <Grid item my={2}>
            <Box
              component="img"
              src={noticia.imagenURL}
              width={"100%"}
              maxWidth={"100%"}
              alt={"imagen - " + noticia.titulo}
              loading="lazy"
            />
          </Grid>
          <Grid className="imgNoticia" item width={{ xs: "90vw", md: "auto" }}>
            <Typography
              variant="parrafo"
              textAlign={"justify"}
            >{Parser(noticia.texto)}</Typography>
          </Grid>
          <Grid item>
            <ListaNoticias cantidadNoticias={4} justify={"center"} />
          </Grid>
        </Grid>
      )}
    </>
  );
}
